export const addToSessionStorageStorage = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

export const getFromSessionStorage = (key: string) => {
  return sessionStorage.getItem(key) || null;
};

export const removeFromSessionStorage = (key: string) => {
  sessionStorage.removeItem(key);
};

export const removeAllFromSessionStorage = () => {
  sessionStorage.clear();
};
